/**
 * Runtime configuration, fetched from /config.json at startup. CDK writes this
 * file into the S3 bucket at deploy time with the real API URL and Cognito ids,
 * so the built bundle is environment-agnostic (no rebuild to change config).
 */

export interface AppConfig {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  region: string;
  /**
   * Local dev harness only: skip Cognito and use an in-browser session. Served
   * by a `vite dev` middleware and never written by CDK, so it is absent in
   * every deployed environment. See packages/backend/dev/README.md.
   */
  devAuth?: boolean;
}

let cached: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('Failed to load app config.');
  cached = (await res.json()) as AppConfig;
  return cached;
}

export function getConfig(): AppConfig {
  if (!cached) throw new Error('Config not loaded yet.');
  return cached;
}
